import { useTranslation } from "react-i18next"
import { LoadingSpinner } from "@/components/loading-spinner"
import { Banner } from "@/components/ui/banner"
import { Dialog, DialogContentCustom, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { BetterDocRecommendationDetails } from "@/modules/admin/better-doc/components/better-doc-recommendation-details"
import { useBetterDocFetch } from "@/modules/admin/better-doc/hooks/useBetterDocFetch"
import { fetchBetterDocRemoteRecommendation } from "@/modules/admin/better-doc/services/betterDocRemoteRecommendationQuery"

type BetterDocRecommendationDialogProps = {
  recommendationId: string
  onClose: () => void
}

export const BetterDocRecommendationDialog = ({ recommendationId, onClose }: BetterDocRecommendationDialogProps) => {
  const { t } = useTranslation()
  const recommendationState = useBetterDocFetch(recommendationId, fetchBetterDocRemoteRecommendation)

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      onClose()
    }
  }

  const renderContent = () => {
    switch (recommendationState.status) {
      case "idle":
      case "loading":
        return <LoadingSpinner size={24} className="flex justify-center p-8" />
      case "failed":
        return (
          <Banner type="inline" variant="critical" data-testid="better-doc-admin-recommendation-dialog-error">
            {t("admin.betterDoc.requestFailed")}
          </Banner>
        )
      case "loaded":
        return <BetterDocRecommendationDetails result={recommendationState.data} />
    }
  }

  return (
    <Dialog open onOpenChange={handleOpenChange}>
      <DialogContentCustom
        className="max-h-[90vh] overflow-y-auto"
        data-testid="better-doc-admin-recommendation-dialog">
        <DialogHeader>
          <DialogTitle>{t("admin.betterDoc.recommendationDialog.title", { recommendationId })}</DialogTitle>
        </DialogHeader>
        <div className="px-6 pb-6">{renderContent()}</div>
      </DialogContentCustom>
    </Dialog>
  )
}
